import { QRCODE_API_PREFIX } from '../constants';

const QRCODE_SERVICE_DOMAIN = __QRCODE_SERVICE_DOMAIN__ ?? '';
const getQRCodeUrl = (text: string): string => `${QRCODE_SERVICE_DOMAIN}${QRCODE_API_PREFIX}?url=${encodeURIComponent(text)}`;

export default getQRCodeUrl;
